import get from 'lodash/get';
import { array, func, number, oneOfType, shape, string } from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  actions as applicationActions,
  getters as applicationGetters,
  helper as applicationHelper,
} from '../Application';
import { getters as formGetters } from '../Form/';

function FormHOC(WrappedComponent, data) {
  const C = class extends Component {
    static propTypes = {
      fetchCase: func.isRequired,
      updateCase: func.isRequired,
      match: shape({
        params: shape({
          index: oneOfType([number, string]),
        }),
      }).isRequired,
      currentApplicant: shape({
        index: number,
      }).isRequired,
      application: shape({
        applicants: array,
      }).isRequired,
    };

    static defaultProps = {};

    constructor(props) {
      super(props);
      this.getSwapAddress = this.getSwapAddress.bind(this);
    }

    componentDidMount() {
      // TODO: this is unnecessary.. we fetch whole case on app-mount
      // here we could just fetch approvalStatus..
      this.props.fetchCase();
    }

    getSwapAddress() {
      const { currentApplicant, application } = this.props;
      return applicationHelper.getSwapAddress(application, currentApplicant);
    }

    handleClick = e => {
      e.preventDefault();
      this.props.updateCase();
    };

    render() {
      const {
        updateCase,
        match: {
          params: { index = 1 },
        },
        ...rest
      } = this.props;
      return (
        <WrappedComponent
          index={index}
          submitForm={this.handleClick}
          swapAddress={this.getSwapAddress()}
          {...rest}
        />
      );
    }
  };

  function mapStateToProps(state, { match: { params } }) {
    const { index = 1 } = params;
    const states = data.state ? { ...data.state(state) } : {};
    return {
      isFormValid: formGetters.isFormValid(state.form),
      isFormDirty: formGetters.isFormDirty(state.form),
      fields: applicationGetters.getFields(state, data.form, index),
      isLoadingButton: state.button.buttonState === 'loading',
      approvalStatus: getApprovalStatus(state),
      approvalStatus1: getApprovalStatus(state, 1),
      approvalStatus2: getApprovalStatus(state, 2),
      currentApplicant: state.application.currentApplicant,
      application: state.application.application,
      ...states,
    };
  }
  function mapDispatchToProps(dispatch, { match: { params } }) {
    const { index = 1 } = params;
    return {
      fetchCase: () => dispatch(applicationActions.fetchCase()),
      updateCase: () =>
        dispatch(applicationActions.updateCase(index, data.form)),
      ...bindActionCreators(
        {
          ...data.actions,
        },
        dispatch
      ),
    };
  }

  function getApprovalStatus({ application: { currentApplicant } }, i) {
    if (!i) {
      return get(currentApplicant, `${data.form}.approvalStatus`);
    }
    const formValue = `${data.field}${i}`;
    return get(currentApplicant, `${data.form}[${formValue}].approvalStatus`);
  }

  return connect(mapStateToProps, mapDispatchToProps)(C);
}

export default FormHOC;



// WEBPACK FOOTER //
// ./src/features/HOC/FormHOC.js